// Axios
import { instance } from './axios.instance';

export const getDocumentTypes = async () => {
  const { data } = await instance.get('/document_types');
  return data;
};
